import "@/App.css";
import { useLenis } from "@/hooks/useLenis";
import { I18nProvider } from "@/i18n";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Manifesto } from "@/components/landing/Manifesto";
import { AppsGrid } from "@/components/landing/AppsGrid";
import { Footer } from "@/components/landing/Footer";

function App() {
  useLenis();

  return (
    <I18nProvider>
      <div className="App" data-testid="app-root">
        <div className="noise-overlay" aria-hidden="true" />
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Manifesto />
          <AppsGrid />
        </main>
        <Footer />
      </div>
    </I18nProvider>
  );
}

export default App;
